import React from "react";

export default function CircularProgressBar(props) {
    return (
        <>
            <div css={`
                width: ${props.width}px;
                height: ${props.height}px;
                border-radius: 50%;
                clip: rect(0px, 75px, 150px, 0px);
            `}>
                <div css={`
                    width: ${props.width}px;
                    height: ${props.height}px;
                    border-radius: 50%;
                    ${props.progress<100 ? 
                    `background: conic-gradient(#1a90ff ${props.progress * 3.6}deg, #fff ${props.progress * 3.6}deg);` 
                    : 
                    `background: green;`
                    }
                    border: 1px solid #ccc
                `}>

                </div>
            </div>
        </>
    )
}